import {CanDeactivateFn} from '@angular/router';
import {Observable} from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component: ComponentCanDeactivate)=>{
    return component.canDeactivate() ? true : confirm('WARNING: You have unsaved changes. Do you want to continue?');
}